import styled from "styled-components";

export const Regular4Style = styled.div`
width:100%;
height:100%;

  .img-fluid {
    display: block;
    max-width: 100%;
  }

  .container8 {
    width:100%;
    height:100%;
    overflow: hidden;
  }

  .f-white {
    color: #fff;
  }


  .back-layer {
    width:100%;
    height:100%;
    background: #ff48d2;
  }

  .back-layer img,
  .back-layer video {
    width:100%;
    height:100%;
    object-fit: cover;
    object-position: center;
    opacity: 0.7;
  }

  .front-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width:100%;
    height:100%;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 10% 100%);
    transform: scale(1.5);
    background: #a64cdf;
    background: -moz-linear-gradient(left, #a64cdf 0%, #ff48d2 100%);
    background: -webkit-linear-gradient(left, #a64cdf 0%, #ff48d2 100%);
    background: linear-gradient(to right, #a64cdf 0%, #ff48d2 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a64cdf', endColorstr='#ff48d2',GradientType=1 );
  }

  .content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .text-wrapper {
    // flex: 0 0 60%;
    position:absolute;
    width:50%;
    height:50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5%;
  }

  text-wrapper > div {
    width:100%;
  }

 
`;
